import { createTask, fetchAssignedTaskDetails } from '../../redux/task/actions'
import { selectErrorCreateTask } from '../../redux/task/selector'
import { AppDispatch, useAppDispatch, useAppSelector } from '../../redux/store'
import { User } from '../../redux/task/types'
import { selectUserTeamMemberInfo } from '../../redux/auth/selector'
import { useLoading } from '../../context/LoadingContext'

interface AddTaskParams {
  title: string
  dueDate: Date | null
  details: string
  link: string
  importance: string
  status: string
  createdBy: User
}

interface UseAddTaskResponse {
  addTask: (params: AddTaskParams) => Promise<void>
  error: string | null
}

const useAddTask = (): UseAddTaskResponse => {
  const dispatch: AppDispatch = useAppDispatch()

  const { setLoading } = useLoading()
  const error = useAppSelector(selectErrorCreateTask)

  const teamMemberDetails = useAppSelector(selectUserTeamMemberInfo)

  const teamMemberDetailsPayload = {
    teamMemberEmail: teamMemberDetails.email,
    teamMemberWorkdayId: teamMemberDetails.workdayId,
  }

  const addTask = async ({
    title,
    createdBy,
    details,
    dueDate,
    importance,
    link,
    status,
  }: AddTaskParams): Promise<void> => {
    setLoading(true)
    try {
      await dispatch(createTask({ title, createdBy, details, dueDate, importance, link, status }))
    } catch (err) {
      console.error('Failed to add task:', err)
    } finally {
      setLoading(false)
      await dispatch(fetchAssignedTaskDetails(teamMemberDetailsPayload)).unwrap()
    }
  }

  return { addTask: addTask, error }
}

export default useAddTask
